import { useEffect, useRef, useState } from 'react';

export function useMediaQuery(mediaQuery: string) {
  const [isMatch, setIsMatch] = useState(false);
  const queryRef = useRef<MediaQueryList | null>(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    // Store the query in useRef instead of a regular variable
    queryRef.current = window.matchMedia(mediaQuery);
    setIsMatch(queryRef.current.matches);

    const handler = (e: MediaQueryListEvent) => setIsMatch(e.matches);

    // Use the ref's current value for the event listener
    queryRef.current.addEventListener('change', handler);

    return () => {
      queryRef.current?.removeEventListener('change', handler);
    };
  }, [mediaQuery]);

  return isMatch;
}
